// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems, noAddonDetails } from './shared';

export const label = 'Buildings';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B21/0639137',
  policyDetailsId: '123445667781',
  coverType: 'Buildings',
  specifiedItems: mockSpecifiedItems,
  addonDetails: noAddonDetails
});
